module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Ka-Ld.d5dce937.png";